export default __webpack_public_path__ + "static/media/verticalresponse.71ce36dc.png";